const UIMessages = ($ => {
    const divMsg = $("<div></div>");

    function createMessage(message, cssClass, container) {
        divMsg.removeClass();
        divMsg.addClass(cssClass).text(message);

        setTimeout(() => {
            divMsg.remove();
        }, 5000);

        $(container).prepend(divMsg);
    }

    return {
        error(message, container) {
            createMessage(message, "msg-error", container);
        },

        warning(message, container) {
            createMessage(message, "msg-warning", container);
        },

        success(message, container) {
            createMessage(message, "msg-success", container);
        },
    }
})(jQuery);
